import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider } from './context/AuthContext';
import { PermissionsProvider } from './context/PermissionsContext';
import { ThemeProvider } from './components/ui-kit';
import App from './App';
import './index.css';
import { FilterProvider } from './context/FilterContext';
import { SortingProvider } from './context/SortingContext';
import OAuthCallback from './pages/OAuthCallback';

// Создаем клиент для React Query
const queryClient = new QueryClient();

// Создаем маршрутизатор с флагами для React Router v7
const router = createBrowserRouter(
  [
    {
      path: '*',
      element: (
        <ThemeProvider>
          <AuthProvider>
            <PermissionsProvider>
              <FilterProvider>
                <SortingProvider>
                  <App />
                  <ToastContainer position="top-right" autoClose={5000} />
                </SortingProvider>
              </FilterProvider>
            </PermissionsProvider>
          </AuthProvider>
        </ThemeProvider>
      ),
    },
    {
      path: '/oauth-callback',
      element: (
        <ThemeProvider>
          <AuthProvider>
            <PermissionsProvider>
              <FilterProvider>
                <SortingProvider>
                  <OAuthCallback />
                  <ToastContainer position="top-right" autoClose={5000} />
                </SortingProvider>
              </FilterProvider>
            </PermissionsProvider>
          </AuthProvider>
        </ThemeProvider>
      ),
    },
  ],
  {
    future: {
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    },
  }
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </React.StrictMode>
);
